export const FLAVOR_SELECTOR_CLASS = 'js-variant-selector';

export const SUBSCRIPTION_INPUT_NAME = 'above-the-fold-subscription';
export const QUANTITY_INPUT_NAME = 'above-the-fold-quantity';
export const FLAVOR_INPUT_NAME = 'above-the-fold-flavor';

export const TOTAL_PRICE_CLASS = 'js-above-the-fold-total-price';
export const SERVING_PRICE_CLASS = 'js-above-the-fold-serving-price';

export const PRICE_SECTION_ID = 'above-the-fold-price-section';
